<div class="tire-size-wrapper ui-g">
  <!-- Basic Info section -->
  <div class="input-basic-info-wrapper input-default-style ui-g-12 p-0"
    *ngIf="!isEnhancedTSEnabled && !companyLocalization">
    <h5 class="input-heading flex-between-center">
      <span *ngIf="tireType !== 'tireStorage'" class="tire-title">Tire {{ index + 1 }} name</span>

      <span *ngIf="index" (click)="handleDeleteSize()"><i class="far fa-times pointer pb-2"></i></span>
    </h5>

    <div class="ui-g-12 p-0 input-control-container">
      <!-- Tire title -->
      <div class="ui-g-4 p-0 flex-start-center">
        <div class="width-100p pl-1 pr-2">
          <app-input tooltipPosition="top"
            [placeholder]="tireType === 'tireStorage' ? 'Tire Storage name' : 'Tire ' + (index + 1) + ' name'"
            [disabled]="isPartsTechItem || isInStorage" [pTooltip]="tireStorageDisabledTooltip"
            [theme]="errors?.title ? 'primary' : 'light'" [floatingLabel]="true" [isInvalid]="errors?.title"
            [maxLength]="100" [value]="size.title" (appChange)="handleChange($event, 'title')"
            (appFocus)="handleFocus('title')" (appBlur)="handleBlur('title')"></app-input>
        </div>
      </div>

      <!-- Tire number -->
      <div class="ui-g-4 p-0 flex-start-center">
        <div class="width-100p pl-1 pr-2">
          <app-input placeholder="AL Part no." theme="light" tooltipPosition="top"
            [pTooltip]="tireStorageDisabledTooltip" [disabled]="isPartsTechItem || isInStorage" [floatingLabel]="true"
            [theme]="errors?.code ? 'primary' : 'light'" [isInvalid]="errors?.code" [value]="size.code"
            (appChange)="handleChange($event, 'code')" (appFocus)="handleFocus('code')"></app-input>
        </div>
      </div>

      <!-- Tire size -->
      <div class="ui-g-4 p-0 flex-start-center">
        <div class="width-100p pl-1">
          <app-input placeholder="Size" tooltipPosition="top" [pTooltip]="tireStorageDisabledTooltip"
            [theme]="errors?.size ? 'primary' : 'light'" [disabled]="isPartsTechItem || isInStorage"
            [floatingLabel]="true" [isInvalid]="errors?.size" [value]="size.size"
            (appChange)="handleChange($event, 'size')" (appFocus)="handleFocus('size')" (appBlur)="handleBlur('size')">
          </app-input>
        </div>
      </div>
    </div>
    <!-- External ID -->
    <div *ngIf="isQTQAddOnEnable || isPassThroughTaxEnable" class="ui-g-12 p-0 input-control-container mt-4">
      <!-- Tire External ID -->
      <div class="ui-g-4 p-0 flex-start-center" *ngIf="isQTQAddOnEnable">
        <div class="width-100p pl-1 pr-2">
          <app-input placeholder="Manufacturer Part Number" [theme]="errors?.tireExternalId ? 'primary' : 'light'"
            [floatingLabel]="true" [isInvalid]="errors?.tireExternalId" [value]="size?.tireExternalId"
            (appChange)="handleChange($event, 'tireExternalId')" (appFocus)="handleFocus('tireExternalId')"
            (appBlur)="handleBlur('tireExternalId')">
          </app-input>
        </div>
      </div>
      <!-- FET -->
      <div class="ui-g-4 p-0 flex-start-center" *ngIf="isPassThroughTaxEnable">
        <div class="width-100p pl-1 pr-2">
          <app-input placeholder="FET rate" [theme]="errors?.fetValue ? 'primary' : 'light'" mask="0*.99"
            [floatingLabel]="true" [allowDecimal]="focus?.fetValue ? true: false" [isInvalid]="errors?.fetValue"
            [disabled]="false"
            [tooltipIconClass]="isTireConnectConnected ? showLoaderTireconnect ? 'far fa-spinner rotate' : 'far fa-redo pointer right-icon-sec '+ getIconColor() : ''"
            tooltipIconPosition="top" tooltipStyleClass="fet-tooltip-tireconnect"
            [tooltipIconText]="isTireConnectConnected ? 'Get FET rate from TireConnect' : ''"
            [value]="focus?.fetValue ? size?.fetValue : (size?.fetValue || 0 | currency: usd)"
            [selectTextOnFocus]="true" (appChange)="handleChange($event, 'fetValue')"
            (appFocus)="handleFocus('fetValue')" (appBlur)="handleBlur('fetValue')"
            (onTooltipIconClicked)="isTireConnectConnected && !showLoaderTireconnect ? getFETRatefromTireConnect() : ''">
          </app-input>
          <span class="flex-end-center" *ngIf="isTireConnectConnected && size?.tireconnectFetValue">
            <span class="fet-rate-btn" (click)="setTireConnectFETRate()" [pTooltip]="'Use this FET rate'"
              tooltipPosition="bottom">{{(size?.tireconnectFetValue || 0) | currency: usd}}
              {{tireConnectFetSouceValues[size?.tireconnectFetSource || '']}}</span>
          </span>
        </div>
      </div>
    </div>
  </div>
  <!-- Basic info section ends -->

  <div class="input-basic-info-wrapper input-default-style ui-g-12 p-0"
    *ngIf="!isEnhancedTSEnabled && companyLocalization">
    <h5 class="input-heading flex-between-center">
      <span *ngIf="tireType !== 'tireStorage'" class="tire-title">Tire {{ index + 1 }} name</span>

      <span *ngIf="index" (click)="handleDeleteSize()"><i class="far fa-times pointer pb-2"></i></span>
    </h5>

    <div class="ui-g-12 p-0 input-control-container">

      <!-- Tire size -->
      <div class="ui-g-4 p-0 flex-start-center">
        <div class="width-100p pl-1">
          <app-input placeholder="Size" tooltipPosition="top" [pTooltip]="tireStorageDisabledTooltip"
            [theme]="errors?.size ? 'primary' : 'light'" [disabled]="isPartsTechItem || isInStorage"
            [floatingLabel]="true" [isInvalid]="errors?.size" [value]="size.size"
            (appChange)="handleChange($event, 'size')" (appFocus)="handleFocus('size')" (appBlur)="handleBlur('size')">
          </app-input>
        </div>
      </div>

      <div class="ui-g-8 p-0 d-flex" [ngClass]="{'flex-row-reverse':currentLang==='fr'}">
        <!-- Tire title -->
        <div class="ui-g-6 p-0 flex-start-center">
          <div class="width-100p pl-1 pr-2">
            <app-input
              [placeholder]="tireType === 'tireStorage' ? 'Tire Storage name' : 'Tire ' + (index + 1) + ' name (EN)' + (currentLang === 'en' ? '*' : '')"
              theme="light" tooltipPosition="top" [pTooltip]="tireStorageDisabledTooltip"
              [disabled]="isPartsTechItem || isInStorage" [floatingLabel]="true"
              [theme]="errors?.title ? 'primary' : 'light'" [isInvalid]="errors?.title" [value]="size.title"
              (appChange)="handleChange($event, 'title')" (appFocus)="handleFocus('title')"></app-input>
          </div>
        </div>
        <div class="ui-g-6 p-0 flex-start-center">
          <div class="width-100p pl-1 pr-2">
            <app-input
              [placeholder]="tireType === 'tireStorage' ? 'Tire Storage name' : 'Tire ' + (index + 1) + ' name (FR)' + (currentLang === 'fr' ? '*' : '')"
              theme="light" tooltipPosition="top" [pTooltip]="tireStorageDisabledTooltip"
              [disabled]="isPartsTechItem || isInStorage" [floatingLabel]="true"
              [theme]="errors?.titleFR ? 'primary' : 'light'" [isInvalid]="errors?.titleFR" [value]="size.titleFR"
              (appChange)="handleChange($event, 'titleFR')" (appFocus)="handleFocus('titleFR')"></app-input>
          </div>
        </div>
      </div>



    </div>
    <!-- External ID -->
    <div *ngIf="isQTQAddOnEnable || isPassThroughTaxEnable" class="ui-g-12 p-0 input-control-container mt-4">
      <!-- Tire External ID -->
      <div class="ui-g-4 p-0 flex-start-center" *ngIf="isQTQAddOnEnable">
        <div class="width-100p pl-1 pr-2">
          <app-input placeholder="Manufacturer Part Number" [theme]="errors?.tireExternalId ? 'primary' : 'light'"
            [floatingLabel]="true" [isInvalid]="errors?.tireExternalId" [value]="size?.tireExternalId"
            (appChange)="handleChange($event, 'tireExternalId')" (appFocus)="handleFocus('tireExternalId')"
            (appBlur)="handleBlur('tireExternalId')">
          </app-input>
        </div>
      </div>
      <!-- FET -->
      <div class="ui-g-4 p-0 flex-start-center" *ngIf="isPassThroughTaxEnable">
        <div class="width-100p pl-1 pr-2">
          <app-input placeholder="FET rate" [theme]="errors?.fetValue ? 'primary' : 'light'" mask="0*.99"
            [floatingLabel]="true" [allowDecimal]="focus?.fetValue ? true: false" [isInvalid]="errors?.fetValue"
            [disabled]="false"
            [tooltipIconClass]="isTireConnectConnected ? showLoaderTireconnect ? 'far fa-spinner rotate' : 'far fa-redo pointer right-icon-sec '+ getIconColor() : ''"
            tooltipIconPosition="top" tooltipStyleClass="fet-tooltip-tireconnect"
            [tooltipIconText]="isTireConnectConnected ? 'Get FET rate from TireConnect' : ''"
            [value]="focus?.fetValue ? size?.fetValue : (size?.fetValue || 0 | currency: usd)"
            [selectTextOnFocus]="true" (appChange)="handleChange($event, 'fetValue')"
            (appFocus)="handleFocus('fetValue')" (appBlur)="handleBlur('fetValue')"
            (onTooltipIconClicked)="isTireConnectConnected && !showLoaderTireconnect ? getFETRatefromTireConnect() : ''">
          </app-input>
          <span class="flex-end-center" *ngIf="isTireConnectConnected && size?.tireconnectFetValue">
            <span class="fet-rate-btn" (click)="setTireConnectFETRate()" [pTooltip]="'Use this FET rate'"
              tooltipPosition="bottom">{{(size?.tireconnectFetValue || 0) | currency: usd}}
              {{tireConnectFetSouceValues[size?.tireconnectFetSource || '']}}</span>
          </span>
        </div>
      </div>
      <div class="ui-g-4 p-0 flex-start-center">
        <div class="width-100p pl-1 pr-2">
          <app-input placeholder="AL Part no." theme="light" tooltipPosition="top"
            [pTooltip]="tireStorageDisabledTooltip" [disabled]="isPartsTechItem || isInStorage" [floatingLabel]="true"
            [theme]="errors?.code ? 'primary' : 'light'" [isInvalid]="errors?.code" [value]="size.code"
            (appChange)="handleChange($event, 'code')" (appFocus)="handleFocus('code')"></app-input>
        </div>
      </div>
    </div>
  </div>


  <!-- Location info section for inventory add -->
  <div [hidden]="openFrom === 'inventoryAdd' || tireType ==='tireStorage' || isFromTireAdd"
    class="ui-g-12 p-0 input-control-container input-default-style mt-2">
    <h5 class="input-heading">Location</h5>

    <div class="ui-g-12 p-0 flex-start-center">
      <div class="width-100p pl-1">
        <app-auto-complete id="tire-locations-{{index}}" listId="tire-locations-list-{{index}}" placeholder="Location"
          [disabled]="(size?.location?.name && isOpenFromPO) && !updateGenericItem" scrollHeight="186px" theme="light"
          name="itemRef" [isInvalid]="errors?.location" styleClassInputWrapper="pl-0" styleClassInput="pl-0"
          [isSetPositionDynamically]="true" vPosition="top" field="name" [value]="size?.location?.name" [fontSize]="14"
          [listItemFontSize]="14" [suggestions]="locationsResults" [isDropdownIconVisible]="true"
          (appFocus)="handleFocus('location')" (appBlur)="handleBlur('location')"
          (appSelect)="handleChange($event, 'location')" (appCompletedMethod)="search($event)"
          (appClear)="handleClear('location')">
          <ng-template let-item let-editItem="editItem" appTemplate="item">
            <div class="tag-item flex-between-center">
              <span class="font-14">{{ item?.name }}</span>
            </div>
          </ng-template>
        </app-auto-complete>
      </div>
    </div>
  </div>

  <!-- Pricing section -->
  <div *ngIf="!isTireStorageList" class="input-basic-info-wrapper input-default-style ui-g-12 p-0">
    <h5 class="input-heading">Pricing</h5>

    <div class="ui-g-12 p-0 input-control-container parts-ddl-border">
      <!-- Cost -->
      <div class="ui-g-4 p-0 flex-start-center">
        <div class="icon flex-center-start" *ngIf="isEnhancedTSEnabled">
          <i class="far fa-receipt height-icon"></i>
        </div>

        <div class="w-40 mr-3 pl-1 " *ngIf="size?.stocked && !isOpenFromPO && !isOpenFromST && !isOpenFromRO">
          <app-auto-complete name="cost-type" field="label" highlightField="highlightField"
            styleClassInput="pl-2 not-allowed" styleClassInputWrapper="" inactiveItemsKey="value"
            styleClassListWrapper="top-38" styleClassError="top-35 left-10" itemWidth="150px" scrollHeight="240px"
            placeholder="Select*" id="part-cost-type" [isSetPositionDynamically]="true" [selectTextOnFocus]="true"
            [delay]="10" [theme]="'primary'"
            [value]="size?.costType === 'cost' ? 'Cost': size?.costType === 'avg' ? 'Avg. Cost' : 'Latest PO'"
            [suggestions]="costOptions" [isDropdownIconVisible]="true" [selectionOnTab]="true"
            [highlightFirstSelectedValue]="true" (appSelect)="handleChange($event, 'costType')">
          </app-auto-complete>
        </div>

        <div class="pl-1 pr-2"
          [ngClass]="size?.stocked && !isOpenFromPO && !isOpenFromST && !isOpenFromRO ? 'w-60' : 'width-100p'">
          <div class="width-100p pl-1 pr-2 position-relative">
            <app-input placeholder="Cost" [theme]="errors?.cost ? 'primary' : 'light'" [disabled]="isPartsTechItem"
              [floatingLabel]="true" [allowDecimal]="focus?.cost ? true: false" [isInvalid]="errors?.cost"
              [disabled]="(size?.costType === 'avg' || size?.costType === 'latestPo') && size?.stocked"
              [value]="focus?.cost ? size.cost : (size.cost || 0 | currency: usd)" [selectTextOnFocus]="true"
              (appChange)="handleChange($event, 'cost')" (appFocus)="handleFocus('cost')"
              (appBlur)="handleBlur('cost')">
            </app-input>
          </div>
        </div>
      </div>

      <!-- Pricing Matrix -->
      <div class="ui-g-4 p-0 flex-start-center">
        <div class="icon flex-center-start" *ngIf="isEnhancedTSEnabled">
          <i class="far fa-th height-icon"></i>
        </div>

        <div class="width-100p pl-1 pr-2"
          [ngClass]="{'disabled-autocomplete': (!isOpenFromRO && isPricingManagementEnable && !isPricingMatricesManagement && (isNewItemCategoriesEnable || isAttributeBasedPricingEnable)) }"
          tooltipPosition="top"
          [pTooltip]="(!isOpenFromRO && isPricingManagementEnable && !isPricingMatricesManagement && (isNewItemCategoriesEnable || isAttributeBasedPricingEnable))  ? 'Please contact admin / store manager to update' : ''">
          <app-auto-complete id="part-markup-{{index}}" listId="part-markup-list-{{index}}" field="name"
            [label]="isAttributeBasedPricingEnable ? 'Pricing rules' : 'Pricing matrix'"
            [placeholder]="isAttributeBasedPricingEnable ? 'Pricing rules' : 'Pricing matrix'" scrollHeight="186px"
            [theme]="errors?.cost ? 'primary' : 'light'" [value]="size?.pricingMatrix?.name" [fontSize]="14"
            [listItemFontSize]="14" [floatingLabel]="true" [listItemFontSize]="13" [disabled]="!size?.cost"
            [suggestions]="pricingMatrixResults" [isDropdownIconVisible]="true"
            [disabled]="(!isOpenFromRO && isPricingManagementEnable && !isPricingMatricesManagement && (isNewItemCategoriesEnable || isAttributeBasedPricingEnable)) "
            (appSelect)="handleChange($event, 'pricingMatrix')"
            (appCompletedMethod)="handleSearch('pricingMatrix', $event)"
            (appClear)="handleClear('pricingMatrix')"></app-auto-complete>
        </div>
      </div>

      <!-- Price -->
      <div class="ui-g-4 p-0 flex-start-center">
        <div class="icon flex-center-start" *ngIf="isEnhancedTSEnabled">
          <i class="far fa-tag height-icon"></i>
        </div>

        <div class="width-100p pl-1"
          [ngClass]="{'disabled-autocomplete': (!isOpenFromRO && isPricingManagementEnable && !isPricingMatricesManagement && (isNewItemCategoriesEnable || isAttributeBasedPricingEnable)) }"
          tooltipPosition="top"
          [pTooltip]="(!isOpenFromRO && isPricingManagementEnable && !isPricingMatricesManagement && (isNewItemCategoriesEnable || isAttributeBasedPricingEnable)) ? 'Please contact admin / store manager to update' : ''">

          <app-input [theme]="errors?.price ? 'primary' : 'light'"
            [placeholder]="isManuallyAdded() ? 'Price (added manually)' : 'Price (calculated)'" [floatingLabel]="true"
            [allowDecimal]="focus?.price ? true: false" [isInvalid]="errors?.price"
            [value]="focus?.price ? size.price : (size.price | currency: usd)" [selectTextOnFocus]="true"
            (appChange)="handleChange($event, 'price')" (appFocus)="handleFocus('price')"
            [disabled]="(!isOpenFromRO && isPricingManagementEnable && !isPricingMatricesManagement && (isNewItemCategoriesEnable || isAttributeBasedPricingEnable)) "
            (appBlur)="handleBlur('price')">
          </app-input>
        </div>
      </div>
    </div>

    <!-- Second raw -->
    <div *ngIf="tireType !== 'tireStorage'" class="ui-g-12 p-0 input-control-container mt-3">
      <!-- Default Qty -->
      <div class="ui-g-4 p-0 flex-start-center">
        <!-- <div class="icon flex-center-start">
          <i class="far fa-boxes height-icon"></i>
        </div> -->

        <div class="width-100p pl-1 pr-2">
          <div class="width-100p position-relative cost-field">
            <div class="width-100p pl-1 pr-2">
              <app-input placeholder="Default qty" [disabled]="isPartsTechItem"
              [theme]="errors?.count ? 'primary' : 'light'" [floatingLabel]="true"
              [allowDecimal]="focus?.count ? true: false" [isInvalid]="errors?.count"
              [value]="focus?.count ? size.count : (size.count | number: '1.2-2')" [selectTextOnFocus]="true"
              (appChange)="handleChange($event, 'count')" (appFocus)="handleFocus('count')"
              (appBlur)="handleBlur('count')">
            </app-input>
            </div>
          </div>
        </div>
      </div>

      <!-- Total cost -->
      <div class="ui-g-4 p-0 flex-start-center">
        <!-- <div class="icon flex-center-start">
          <i class="far fa-receipt height-icon"></i>
        </div> -->

        <div class="width-100p pl-1 pr-2">
          <app-input placeholder="Total cost" theme="light" [floatingLabel]="true"
            [allowDecimal]="focus?.totalCost ? true: false" [isInvalid]="errors?.totalCost" [disabled]="true"
            [value]="focus?.totalCost ? size.totalCost : (size.totalCost | currency: usd)" [selectTextOnFocus]="true">
          </app-input>
        </div>
      </div>

      <!-- Total price -->
      <div class="ui-g-4 p-0 flex-start-center">
        <!-- <div class="icon flex-center-start">
          <i class="far fa-tags height-icon"></i>
        </div> -->

        <div class="width-100p pl-1">
          <app-input placeholder="Total price" theme="light" [floatingLabel]="true"
            [allowDecimal]="focus?.totalPrice ? true: false" [isInvalid]="errors?.totalPrice" [disabled]="true"
            [value]="focus?.totalPrice ? size.totalPrice : (size.totalPrice | currency: usd)"
            [selectTextOnFocus]="true">
          </app-input>
        </div>
      </div>
    </div>
  </div>
  <!-- Pricing section ends -->

  <!-- Reorder detail section -->
  <div
    *ngIf="(size?.hasMarkedInventory || size?.stocked || !isOpenFromRO) && isInventoryEnabled && tireType !=='tireStorage'"
    class="input-inventory-wrapper input-default-style ui-g-12 p-0">
    <h5 class="input-heading">Inventory details</h5>

    <!-- Mark as Inventory -->
    <div *ngIf="isMarkAsInventoryEnabled" class="input-additional-wrapper input-default-style ui-g-12 p-0">
      <!-- First row -->
      <div class="ui-g-12 p-0 input-control-container">
        <div class="ui-g-4 p-0 flex-start-center">
          <!-- <div class="icon flex-center-start">
            <i class="far fa-ballot-check height-icon"></i>
          </div> -->

          <div class="width-100p pl-1 pr-2">
            <app-switch-pill label="Mark as inventory" position="end" [fontSize]="12"
              [isActive]="size?.hasMarkedInventory || size?.stocked" [disabled]="size?.stocked"
              (appChange)="handleChange($event, 'hasMarkedInventory')"> </app-switch-pill>
          </div>
        </div>

        <div class="ui-g-4 p-0 flex-start-center">
        </div>
      </div>
    </div>
    <!-- Mark as Inventory -->

    <div class="ui-g-12 p-0 mb-3">
      <div class="d-flex p-0 ui-g-6 inventory-details-wrapper">
        <div class="ui-g-3 d-flex font-12">
          <i class="far fa-boxes align-self-center height-icon"></i>
          <span class="px-2 align-self-center">Available</span>
          <span class="font-bold align-self-center">{{size?.qtyAvailable | number: '1.2-2'}}</span>
        </div>

        <div class="ui-g-1 pl-4 align-self-center">
          <i class="fas fa-equals"></i>
        </div>

        <div class="ui-g-3 d-flex font-12">
          <span class="px-2 align-self-center">On hand</span>
          <span class="font-bold align-self-center">{{size.qtyOnHand | number: '1.2-2'}}</span>
        </div>

        <div class="ui-g-1 align-self-center">
          <i class="fas fa-minus"></i>
        </div>

        <div class="ui-g-4 d-flex font-12">
          <span class="px-2 align-self-center">On Estimates</span>
          <span class="font-bold align-self-center">{{size.qtyOnOrder | number: '1.2-2'}}</span>
        </div>

      </div>

      <div class="d-flex ui-g-2 mx-3 font-12 inventory-details-wrapper">
        <i class="far fa-truck align-self-center height-icon"></i>
        <span class="px-2 align-self-center">Ordered</span>
        <span class="font-bold align-self-center">{{size.qtyOrdered | number: '1.2-2'}}</span>
      </div>

      <div *ngIf="size?.stocked" class="ui-g-3 ml-4 pt-0" style="min-height: 40px;"
        (click)="graphdata(size.tireID, tireType)">
        <div class="icon part-sales-trends">
          <app-history-inv-sales-chart [type]="tireType" [itemId]="size.tireID" label="Historical sales/reorder trend">
          </app-history-inv-sales-chart>
        </div>
        <div class="icon part-sales-trends">
          <div (click)="openQtyOnEstimateModal(size)" class="d-flex pointer">
            <i class="far fa-calendar-check font-primary align-self-center"></i>
            <p class="mb-0 font-bold font-14 font-primary pl-2">Qty on estimates detail</p>
          </div>
        </div>
      </div>
    </div>

    <div class="ui-g-12 p-0 input-control-container my-2 mb-3">
      <div class="ui-g-4 p-0 flex-start-center">
        <!-- <div class="icon flex-center-start">
          <i class="far fa-pallet height-icon"></i>
        </div> -->

        <div class="width-100p pl-1 pr-2 position-relative cost-field">
          <app-input class="error" id="tire-qty-on-restock-{{ index }}" type="text"
            [allowDecimal]="focus?.restockLevel ? true: false" placeholder="Minimum quantity level / reorder level"
            theme="light" [fontSize]="14" [floatingLabel]="true" [errorMessage]="errors?.restockLevel"
            [isInvalid]="errors?.restockLevel"
            [value]="focus?.restockLevel ? size.restockLevel : (size.restockLevel | number: '1.2-2')"
            (appChange)="handleChange($event, 'restockLevel')" (appFocus)="handleFocus('restockLevel')"
            (appBlur)="handleBlur('restockLevel')">
          </app-input>
        </div>
      </div>

      <div class="ui-g-4 p-0 flex-start-center">
        <!-- <div class="icon flex-center-start">
          <i class="far fa-pallet height-icon"></i>
        </div> -->

        <div class="width-100p pl-1 pr-2 position-relative cost-field">
          <app-input id="tire-qty-on-maxQuantity-{{ index }}" type="text"
            [allowDecimal]="focus?.maxQuantity ? true : false" placeholder="Maximum quantity level" theme="light"
            [fontSize]="14" [floatingLabel]="true"
            [value]="focus?.maxQuantity ? size.maxQuantity : (size.maxQuantity | number: '1.2-2')"
            (appChange)="handleChange($event, 'maxQuantity')" (appFocus)="handleFocus('maxQuantity')"
            (appBlur)="handleBlur('maxQuantity')">
          </app-input>
        </div>
      </div>

      <div class="ui-g-4 p-0 input-control-container">
        <div class="ui-g-12 p-0 flex-start-center">
          <!-- <div class="icon flex-center-start">
            <i class="far fa-warehouse-alt height-icon"></i>
          </div> -->

          <div class="width-100p pl-1">
            <app-auto-complete id="tire-locations-{{index}}" listId="tire-locations-list-{{index}}"
              placeholder="Location" [disabled]="!!tireId && isOpenFromPO && !updateGenericItem" scrollHeight="186px"
              theme="light" name="itemRef" [isInvalid]="errors?.location" styleClassInputWrapper="pl-0"
              styleClassInput="pl-0" vPosition="top" field="name" [floatingLabel]="true"
              [isSetPositionDynamically]="true" [value]="size?.location?.name" [fontSize]="14" [listItemFontSize]="14"
              [suggestions]="locationsResults" [isDropdownIconVisible]="true" (appFocus)="handleFocus('location')"
              (appBlur)="handleBlur('location')" (appSelect)="handleChange($event, 'location')"
              (appCompletedMethod)="search($event)" (appClear)="handleClear('location')">
              <ng-template let-item let-editItem="editItem" appTemplate="item">
                <div class="tag-item flex-between-center">
                  <span class="font-14">{{ item?.name }}</span>
                </div>
              </ng-template>
            </app-auto-complete>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- General settings info section -->
  <div *ngIf="!isTireStorageList" class="input-general-settings-wrapper input-default-style ui-g-12 p-0">
    <h5 class="input-heading">General settings</h5>

    <div class="ui-g-12 p-0 input-control-container mb-3">
      <div class="ui-g-12 p-0 min-height-50">
        <!-- Taxable -->
        <div class="ui-g-4 p-0 flex-start-center">
          <!-- <div class="icon flex-center-start">
            <i class="far fa-landmark-alt height-icon"></i>
          </div> -->

          <div class="width-100p pl-1 pr-2">
            <app-switch-pill label="Taxable" position="end" [fontSize]="12" [isActive]="size?.isTaxable"
              (appChange)="handleChange($event, 'isTaxable')"> </app-switch-pill>
          </div>
        </div>

        <!-- Display hours -->
        <div class="ui-g-4 p-0 flex-start-center">
          <!-- <div class="icon flex-center-start">
            <i class="far fa-boxes height-icon"></i>
          </div> -->

          <div class="width-100p pl-1 pr-2">
            <app-switch-pill label="Display desc. on estimate & invoice" position="end"
              [isActive]="size?.displayDescOnOrder" [fontSize]="12"
              (appChange)="handleChange($event, 'displayDescOnOrder')">
            </app-switch-pill>
          </div>
        </div>

        <!-- Commissionable -->
        <div *ngIf="isCommissionPlanEnabled" class="ui-g-4 p-0 flex-start-center">
          <!-- <div class="icon flex-center-start">
            <i class="far fa-sack height-icon"></i>
          </div> -->

          <div class="width-100p pl-1 pr-2">
            <app-switch-pill label="Commissionable" position="end" [isActive]="size?.commissionable" [fontSize]="12"
              (appChange)="handleChange($event, 'commissionable')">
            </app-switch-pill>
          </div>
        </div>
      </div>

      <div class="ui-g-12 p-0 min-height-50">
        <!-- Status -->
        <div class="ui-g-4 p-0 flex-start-center pt-2">
          <!-- <div class="icon flex-center-start">
            <i class="far fa-info-circle height-icon"></i>
          </div> -->

          <div class="width-100p pl-1 pr-2">
            <app-switch-pill label="Active" position="end" [disabled]="!!orderServiceId && !updateGenericItem"
              [isActive]="size?.status" [fontSize]="12" (appChange)="handleChange($event, 'status')">
            </app-switch-pill>
          </div>
        </div>

        <!-- Display Qty -->
        <div class="ui-g-4 p-0 flex-start-center pt-2">
          <!-- <div class="icon flex-center-start">
            <i class="far fa-file-invoice height-icon"></i>
          </div> -->

          <div class="width-100p pl-1 pr-2">
            <app-switch-pill label="Display qty. & price on estimate & invoice" position="end"
              [isActive]="size?.displayHoursOnOrder" [fontSize]="12"
              (appChange)="handleChange($event, 'displayHoursOnOrder')">
            </app-switch-pill>
          </div>
        </div>

        <!-- QuickBooks Reference -->
        <div *ngIf="isQboConnected" class="ui-g-4 p-0 flex-start-center">
          <!-- <div class="icon flex-center-start">
            <i class="far fa-coins height-icon"></i>
          </div> -->

          <div class="width-100p pl-1">
            <app-auto-complete placeholder="QBO item reference" theme="light" scrollHeight="165px" name="itemRef"
              field="title" [floatingLabel]="true" [value]="size?.qboItemRef?.title" [suggestions]="qboItemRefs"
              [isDropdownIconVisible]="true" [fontSize]="14" [listItemFontSize]="14"
              (appSelect)="handleChange($event, 'qboItemRef')" (appCompletedMethod)="onSearchItem($event)"
              (appClear)="handleClear()">
            </app-auto-complete>
          </div>
        </div>
      </div>
    </div>

    <div class="ui-g-12 p-0 input-control-container">
      <div [ngClass]="{'d-flex flex-column-reverse':currentLang==='fr'}">

        <div class="ui-g-12 p-0 flex-start-center" [ngClass]="{'mt-2':currentLang === 'fr'}">
          <!-- <div class="icon flex-center-start">
          <i class="far fa-sticky-note height-icon"></i>
        </div> -->

          <div class="width-100p pl-1">
            <app-textarea [placeholder]="'Description ' + (companyLocalization ? '(EN)' : '')" theme="light"
              [maxLength]="10000" [floatingLabel]="true" [textAreaId]="'tie-save-dialog' + index" [autoGrow]="true"
              [maxAutoGrowHeight]="64" [rows]="1" [isInvalid]="errors?.description" [value]="size?.description"
              [rows]="1" (appChange)="handleChange($event, 'description')" (appFocus)="handleFocus('description')"
              (appBlur)="handleBlur('description')">
            </app-textarea>
          </div>
        </div>
        <div class="ui-g-12 p-0 flex-start-center" [ngClass]="{'mt-2':currentLang === 'en'}"
          *ngIf="companyLocalization">
          <!-- <div class="icon flex-center-start">
          <i class="far fa-sticky-note height-icon"></i>
        </div> -->

          <div class="width-100p pl-1">
            <app-textarea [placeholder]="'Description (FR)'" theme="light" [maxLength]="10000" [floatingLabel]="true"
              [textAreaId]="'tie-save-dialog' + index" [autoGrow]="true" [maxAutoGrowHeight]="64" [rows]="1"
              [isInvalid]="errors?.descriptionFR" [value]="size?.descriptionFR" [rows]="1"
              (appChange)="handleChange($event, 'descriptionFR')" (appFocus)="handleFocus('descriptionFR')"
              (appBlur)="handleBlur('descriptionFR')">
            </app-textarea>
          </div>
        </div>
      </div>

      <div class="ui-g-12 mt-2 p-0 flex-start-center">
        <!-- <div class="icon flex-center-start">
          <i class="far fa-sticky-note height-icon"></i>
        </div> -->

        <div class="width-100p pl-1">
          <app-textarea placeholder="Internal notes" theme="light" [floatingLabel]="true"
            id="internal-tire-desc-{{index}}" [textAreaId]="'internal-tire-desc-textarea' + index" [autoGrow]="true"
            [maxAutoGrowHeight]="64" [rows]="1" [isInvalid]="errors?.internalNotes" [value]="size?.internalNotes"
            [rows]="1" (appChange)="handleChange($event, 'internalNotes')" (appFocus)="handleFocus('internalNotes')"
            (appBlur)="handleBlur('internalNotes')">
          </app-textarea>
        </div>
      </div>
    </div>
  </div>
  <!-- General settings info section ends -->

  <!-- Reorder detail section end -->
  <!-- Inventory section -->
  <!-- <div *ngIf="(size?.hasMarkedInventory || size?.stocked) && isInventoryEnabled"
    class="input-inventory-wrapper input-default-style ui-g-12 p-0 pt-3">
    <h5 class="input-heading">Inventory</h5>

    <div class="ui-g-12 p-0 input-control-container mt-2">
      <div class="ui-g-3 p-0 flex-start-center">
        <div class="icon flex-center-start">
          <i class="far fa-hand-holding-box height-icon"></i>
        </div>

        <div class="width-100p pl-1 pr-2 position-relative cost-field">
          <app-input id="tire-qty-on-hand-{{ index }}" type="text" [allowDecimal]="true" placeholder="Qty on hand"
            theme="light" [fontSize]="14" [floatingLabel]="true" [disabled]="true"
            [value]="size.qtyOnHand | number: '1.2-2'">
          </app-input>
        </div>
      </div>

      <div class="ui-g-3 p-0 flex-start-center">
        <div class="icon flex-center-start">
          <i class="far fa-th-large height-icon"></i>
        </div>

        <div class="width-100p pl-1 pr-2 position-relative cost-field">
          <app-input id="tire-qty-on-order-{{ index }}" type="text" [allowDecimal]="true" placeholder="Qty on estimates"
            theme="light" [fontSize]="14" [floatingLabel]="true" [disabled]="true"
            [value]="size.qtyOnOrder | number: '1.2-2'">
          </app-input>
        </div>
      </div>

      <div class="ui-g-3 p-0 flex-start-center">
        <div class="icon flex-center-start">
          <i class="far fa-boxes height-icon"></i>
        </div>

        <div class="width-100p pl-1">
          <app-input id="tire-qty-available-{{ index }}" type="text" placeholder="Qty available" theme="light"
            [disabled]="true" [fontSize]="14" [floatingLabel]="true" [value]="size?.qtyAvailable | number: '1.2-2'">
          </app-input>
        </div>
      </div>

      <div class="ui-g-3 p-0 flex-start-center">
        <div class="icon flex-center-start">
          <i class="far fa-truck height-icon"></i>
        </div>

        <div class="width-100p pl-1 pr-2 position-relative cost-field">
          <app-input id="tire-qty-ordered-{{ index }}" type="text" [allowDecimal]="true" placeholder="Qty ordered"
            theme="light" [fontSize]="14" [floatingLabel]="true" [disabled]="true"
            [value]="size.qtyOrdered | number: '1.2-2'">
          </app-input>
        </div>
      </div>
    </div>

    <div class="ui-g-12 p-0 input-control-container mt-2">
      <div class="ui-g-12 p-0 flex-start-center">
        <div class="icon flex-center-start">
          <i class="far fa-warehouse-alt height-icon"></i>
        </div>

        <div class="width-100p pl-1">
          <app-auto-complete id="tire-locations-{{index}}" listId="tire-locations-list-{{index}}" placeholder="Location"
            [disabled]="isOpenFromPO && !updateGenericItem" scrollHeight="186px" theme="light" name="itemRef"
            [isInvalid]="errors?.location" styleClassInputWrapper="pl-0" styleClassInput="pl-0"
            [isSetPositionDynamically]="true" vPosition="top" field="name" [value]="size?.location?.name"
            [fontSize]="14" [listItemFontSize]="14" [suggestions]="locationsResults" [isDropdownIconVisible]="true"
            (appFocus)="handleFocus('location')" (appBlur)="handleBlur('location')"
            (appSelect)="handleChange($event, 'location')" (appCompletedMethod)="search($event)"
            (appClear)="handleClear('location')">
            <ng-template let-item let-editItem="editItem" appTemplate="item">
              <div class="tag-item flex-between-center">
                <span class="font-14">{{ item?.name }}</span>
              </div>
            </ng-template>
          </app-auto-complete>
        </div>
      </div>
    </div>
  </div> -->

  <div class="input-default-style ui-g-12 p-0 mb-3" *ngIf="isFeeAssociationEnabled && tireType === 'tire'">
    <h5 class="input-heading">Fee</h5>
    <div class="hazmat-fee-wrapper" *ngFor="let hazmatFee of size.hazmatFeeArray; let i = index">
      <div class="hazmat-wrapper">
        <div class="hazmat-fee-search-wrapper">
          <app-auto-complete placeholder="Search Fee" field="title" theme="primary" leftIcon="fad fa-hard-hat"
            styleClassInputWrapper="p-0 pl-1" styleClassInput="p-1" width="500px" [disabled]="isOpenFromRO"
            [isLoading]="isSearching" [value]="hazmatFee?.title" [fontSize]="14" [hasEditableField]="false"
            [openDropdownOnGetResult]="true" [hasSearchIcon]="true" [closeOnSelection]="true"
            [suggestions]="itemResults[i]" (appSelect)="handleSelect($event, i)"
            (appCompletedMethod)="handleSearchSuggestion($event, i)" scrollHeight="288px">
            <ng-template let-item let-query="query" appTemplate="item">
              <div class="fee-search-item flex-start-center width-100p">
                <i class="fal far fa-usd-circle font-gray-75 p-2"></i>
                <div class="flex-start-center width-100p">
                  <div class="flex-column width-100p">
                    <div class="search-item-header flex-between-center width-100p">
                      <div class="search-title-wrapper">
                        <p class="m-0 text-truncate search-title">{{ helperService.getLocalizationValue(currentLang, item, 'title')}}</p>
                        <p class="m-0 text-truncate font-11 font-gray-55 search-description width-100p">
                          {{ item?.description ? item?.description : 'No description' }}
                        </p>
                      </div>

                      <div class="m-0 text-truncate search-price-cost width-100p text-right">
                        <p class="search-price m-0 font-600">Price: {{ item.price || 0 | currency: usd }}</p>
                        <p class="search-cost m-0">Cost: {{ item.cost || 0 | currency: usd }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </app-auto-complete>
        </div>

        <p *ngIf="hazmatFee?.feeValueType && hazmatFee?.feeValueType === 'percent'; else typeFixedTemplate">
          * Total fee will be equal to {{ (hazmatFee?.price / 100) * size.price || 0 | currency: usd }} per unit of the
          item ({{ hazmatFee?.price }}% * {{ size.price || 0 | currency: usd }})
        </p>

        <ng-template #typeFixedTemplate>
          <p>* Total fee will be equal to {{ hazmatFee?.price || 0 | currency: usd }} per unit of the item</p>
        </ng-template>
      </div>

      <div class="deleteButton" *ngIf="hazmatFee?._id && !isOpenFromRO">
        <button class="del-btn" (click)="handleRemove(i)">
          <i class="fal fa-trash"></i>
        </button>
      </div>
    </div>

    <p class="mt-1 mb-4 font-primary font-600 pointer" *ngIf="!isOpenFromRO" (click)="handleFeeAddition()">
      <ng-container *ngIf="size.hazmatFeeArray.length > 0; else showFeeText"> <i class="fad fa-plus-circle mr-2"></i>
        Add another fees </ng-container>

      <ng-template #showFeeText> <i class="fad fa-plus-circle mr-2"></i> Add another fee </ng-template>
    </p>
  </div>
</div>